import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueResource from 'vue-resource'
import VueScrollto from 'vue-scrollto'
import Fingerprint2 from 'fingerprintjs2'
import Cookie from 'js-cookie'
import Vuebar from 'vuebar'

import '@/components/ui'
import '@/components/blocks'
import '@/components/sections'
import '@/filters'
import '@/components/icons'

Vue.config.productionTip = false
Vue.use(VueResource)
Vue.use(VueScrollto)
Vue.use(Vuebar)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

if (window.requestIdleCallback) {
    requestIdleCallback(getPrint)
} else {
    setTimeout(getPrint, 500)
}

function getPrint () {
    Fingerprint2.get(function (components) {
        let values = components.map(function (component) { return component.value })
        let hash = Fingerprint2.x64hash128(values.join(''), 31)
        Cookie.set('fgphash', hash)
    })
}
